export const getTextSize = (txt, fontSize = 12, fontWeight = 'normal') => {
  const element = document.createElement('canvas')
  const context = element.getContext('2d')
  context.font = `${fontWeight} ${fontSize}px SFProDisplay`
  return {
    width: Math.ceil(context.measureText(txt).width),
    height: Math.ceil(context.measureText('M').width), // the width of a single capital 'M' at a given font size is about the same as the line height.
  }
}

export const getElementSize = (
  elementHtml,
  fontSize = 12,
  fontWeight = 'normal',
) => {
  const el = document.createElement('span')
  el.style.fontSize = fontSize + 'px'
  el.style.fontWeight = fontWeight
  el.innerHTML = elementHtml
  document.body.appendChild(el, document.body.firstChild)
  const size = { width: el.offsetWidth, height: el.offsetHeight }
  el.remove()
  return size
}
